<template>
  <div>
    <div
      style="max-width: 600px; border: 1px solid #bbb; transition: box-shadow .2s ease,-webkit-box-shadow .2s ease; padding: 5px;"
      id="card-element"
    ></div>

    <div class="payment-button">
      <b-button
        v-on:click="purchase"
        variant="outline-success"
        v-if="!paymentLoading"
        >Pay £{{ amount }}</b-button
      >
      <div v-if="paymentLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StripePayment",
  props: {
    amount: {
      type: String,
      required: true
    },
    gtagReference: {
      type: String,
      required: true
    },
    isCredit: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.setup();
  },
  mounted: function() {
    this.configureStripe();
  },
  data() {
    return {
      stripeAPIToken: null,
      stripe: "",
      elements: "",
      card: "",
      stripeElementsSecret: "",
      paymentLoading: false
    };
  },
  methods: {
    setup() {
      if (this.isCredit) {
        this.stripeAPIToken = process.env.VUE_APP_STRIPE_CREDIT_PUBLIC_KEY;
        return;
      }
      this.stripeAPIToken = process.env.VUE_APP_STRIPE_PUBLIC_KEY;
    },
    setPaymentLoading() {
      this.paymentLoading = true;
    },
    loadPayment(secret) {
      this.stripeElementsSecret = secret;
      this.$nextTick(() => {
        this.card.mount("#card-element");
      });
    },
    purchase() {
      this.paymentLoading = true;
      this.stripe
        .confirmCardPayment(this.stripeElementsSecret, {
          payment_method: {
            card: this.card
          }
        })
        .then(result => {
          if (result.error) {
            let gTagCategory = `paymentError${this.gtagReference}Card`;
            let eventLabel = result.error.message;
            let customerError = result.error.message;

            if (result.error.type !== "card_error") {
              gTagCategory = `paymentError${this.gtagReference}App`;
              customerError =
                "We were unable to process this payment. Please contact us if this issue persists.";
            }

            if (result.error.type === "validation_error") {
              customerError = result.error.message;
            }

            if (
              result.error.payment_method &&
              result.error.payment_method.card.brand === "amex"
            ) {
              eventLabel = "amex";
              customerError =
                "We no longer accept American Express Payments. Please use an alternative payment method";
            }

            this.$gtag.event(result.error.type, {
              event_category: gTagCategory,
              event_label: eventLabel
            });
            // Show error to your customer (e.g., insufficient funds)
            const title = "Payment Error";
            const subtitle = customerError;
            const samePage = true;
            this.$store.dispatch("pushError", { title, subtitle, samePage });
            this.$emit("error");
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === "succeeded") {
              this.$gtag.event("payment", {
                event_category: `paymentSuccess${this.gtagReference}`
              });
              this.card.clear();
              this.stripeElementsSecret = null;

              const title = "Payment Processing";
              const subtitle =
                "Your payment will appear on your dashboard shortly";
              const samePage = true;
              this.$store.dispatch("pushSuccess", {
                title,
                subtitle,
                samePage
              });

              this.$emit("complete");
            }
          }
          this.paymentLoading = false;
        });
    },
    configureStripe() {
      this.stripe = window.Stripe(this.stripeAPIToken);

      let style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      this.elements = this.stripe.elements();
      this.card = this.elements.create("card", { style: style });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../scss/dashboard.scss";

.payment-input input {
  border-radius: 0;
}

.payment-requests {
  text-align: left;
  font-size: 0.8rem;
}
</style>
